import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCompanySuppliersAction, getFlyersBasedOnRole } from './APIs/action';
import { SupplierModuleTypeEnum } from '../../../utils/settings';

const HumbeeBenefits = () => {
  const [companyList, setCompanyList] = useState([]);
  const [RoleList, setRoleList] = useState([]);
  const [selectedRoleData, setSelectedRoleData] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedRoleValue, setSelectedRoleValue] = useState('');

  const getCompany = async () => {
    const { error, data, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.flyers_enabled,
    );
    if (!error) {
      const temp = data
        .map((item) => {
          return item.suppliers_list;
        })
        .flat();

      setCompanyList(
        temp.map((item) => {
          return {
            label: item?.name,
            value: item?.id,
            key: item?.id,
          };
        }),
        setSelectedCompany(temp[0]?.id),
      );
    } else {
      toast.error(message);
    }
  };
  const getRole = async () => {
    const { data, error, message } = await getFlyersBasedOnRole(
      selectedCompany,
    );
    if (!error) {
      const temp = data || []; // Handle empty data gracefully
      setRoleList(
        temp.map((item) => ({
          display_name: item.display_name,
          firm_role_id: item.firm_role_id,
          flyer_url: item.flyer_url,
        })),
        setSelectedRoleValue(temp[0].firm_role_id),
        setSelectedRoleData(temp[0]),
      );
    } else {
      setRoleList([]);
      setSelectedRoleData(null);
      setSelectedRoleValue(null);
      toast.error(message);
    }
  };
  useEffect(() => {
    if (selectedCompany) {
      getRole();
    }
  }, [selectedCompany]);

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (event) => {
    setSelectedRoleData(null);
    setSelectedRoleValue(null);
    setSelectedCompany(event.target.value);
  };
  const handleRoleChange = (event) => {
    const selectedRoleId = event.target.value;
    const roleData = RoleList.find(
      (role) => role.firm_role_id === selectedRoleId,
    );
    setSelectedRoleData(roleData);
    setSelectedRoleValue(selectedRoleId);
  };
  const isSmallScreen = useMediaQuery('(max-width:1024px)');
  return (
    <div>
      <Container
        maxWidth='true'
        sx={{ pl: '2rem', pt: '3rem' }}
      >
        <Box>
          <Typography variant='h4'>Humbee Benefits</Typography>
          <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        </Box>

        <Box sx={{ width: '100%' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Select Company</InputLabel>
                <Select label='Select Company' onChange={handleCompanyChange} value={selectedCompany}>
                  {companyList.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Select Role</InputLabel>
                <Select label='Select Role' onChange={handleRoleChange} value={selectedRoleValue}>
                  {RoleList.length > 0 ? (
                    RoleList.map((item) => (
                      <MenuItem key={item.firm_role_id} value={item.firm_role_id}>
                        {item.display_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value='' disabled>
                      No roles available
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            mt: '1rem',
            width: { xs: '100%', lg: '100%'},
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {selectedCompany && selectedRoleData ? (
            <img
              src={selectedRoleData.flyer_url}
              alt='flyer'
              // width='50%'
              style={{ width: isSmallScreen ? '100%' : '50%' }}
            />
          ) : (
            ''
          )}
        </Box>
      </Container>
    </div>
  );
};

export default HumbeeBenefits;
